<div class="liste-container">

  <!-- HEADER -->
  <div class="page-header">

    <div class="header-left">

      <button mat-icon-button (click)="back()" [matTooltip]="zurueckText">

        <mat-icon>
          arrow_back
        </mat-icon>

      </button>

      <h1 class="page-title">
        {{ liste?.name || 'Messstellenliste' }}
      </h1>

    </div>

  </div>


  <!-- Offline-Status: Stand der lokal verfügbaren Daten -->
  <mat-card class="offline-banner" *ngIf="istOffline && !isLoading">
    <mat-card-content>
      <mat-icon>cloud_off</mat-icon>
      <span>
        Offline · Datenstand {{ standUtc | date:'dd.MM.yyyy HH:mm' }}
      </span>
    </mat-card-content>
  </mat-card>


  <!-- LOADING -->
  <div class="loading" *ngIf="isLoading">

    <mat-spinner diameter="40">
    </mat-spinner>

  </div>


  <!-- FEHLER -->
  <mat-card class="hint-card" *ngIf="loadError">

    <mat-card-content>
      {{ loadError }}
    </mat-card-content>

  </mat-card>


  <ng-container *ngIf="!isLoading && liste">


    <!-- =====================================================
         META
         ===================================================== -->

    <mat-card class="meta-card">

      <mat-card-content>

        <div class="meta-row">

          <span class="count-chip">
            {{ liste.messstellenCount }} Messstellen
          </span>


          <!-- PROJEKT -->
          <span class="meta-item projekt-meta" *ngIf="liste.projektId">

            <mat-icon>
              folder
            </mat-icon>

            <span>

              <strong>
                {{ liste.projektNummer || 'Projekt' }}
              </strong>

              <ng-container *ngIf="liste.projektName">

                · {{ liste.projektName }}

              </ng-container>

            </span>

          </span>


          <!-- KEIN PROJEKT -->
          <div class="projekt-zuordnung" *ngIf="!liste.projektId">

            <div class="projekt-zuordnung-label">

              <mat-icon>
                folder_open
              </mat-icon>

              <span>
                Kein Projekt zugeordnet
              </span>

            </div>


            <!-- Zuordnen nur mit Schreibrecht; lesend bleibt der Hinweis stehen. -->
            <ng-container *ngIf="canEdit">

              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="projekt-select">

                <mat-label>
                  Projekt auswählen
                </mat-label>

                <mat-select [(ngModel)]="selectedProjektId" [disabled]="
                  loadingProjekte ||
                  assigningProjekt ||
                  projekte.length === 0
                ">

                  <mat-option *ngFor="
                    let projekt of projekte;
                    trackBy: trackByProjekt
                  " [value]="projekt.id">

                    {{ projekt.projektNummer }}
                    ·
                    {{ projekt.name }}

                  </mat-option>

                </mat-select>

              </mat-form-field>


              <button mat-stroked-button color="primary" type="button" class="projekt-zuordnen-button" [disabled]="
                !selectedProjektId ||
                loadingProjekte ||
                assigningProjekt
              " (click)="projektZuordnen()">

                <mat-spinner diameter="16" *ngIf="assigningProjekt">
                </mat-spinner>

                <mat-icon *ngIf="!assigningProjekt">

                  link

                </mat-icon>

                <span *ngIf="!assigningProjekt">

                  Zuordnen

                </span>

              </button>


              <span class="projekt-ladehinweis" *ngIf="loadingProjekte">

                Projekte werden geladen …

              </span>


              <span class="projekt-ladehinweis" *ngIf="
                !loadingProjekte &&
                projekte.length === 0 &&
                !projektAssignmentError
              ">

                Kein passendes Projekt für diesen Kunden vorhanden.

              </span>

            </ng-container>

          </div>


          <!-- KUNDE -->
          <span class="meta-item" *ngIf="liste.customerName">

            <mat-icon>
              business
            </mat-icon>

            {{ liste.customerName }}

          </span>


          <!-- MANUELL ERSTELLT: Struktur statt Datei -->
          <span class="meta-item manuell-meta" *ngIf="istManuelleListe"
            matTooltip="Diese Liste wurde ohne Excel mit eigener Spaltenstruktur erstellt">
            <mat-icon>view_column</mat-icon>
            <span>
              Manuell erstellt · {{ strukturSpalten.length }} Spalten ·
              Kennzeichnung <strong>{{ strukturKennzeichnung?.name }}</strong>
            </span>
          </span>

          <!-- DATEI -->
          <span class="meta-item" *ngIf="liste.fileName">

            <mat-icon>
              description
            </mat-icon>

            {{ liste.fileName }}

          </span>


          <!-- SHEET -->
          <span class="meta-item" *ngIf="liste.sheetName">

            <mat-icon>
              tab
            </mat-icon>

            {{ liste.sheetName }}

          </span>


          <!-- IMPORT -->
          <span class="meta-item">

            <mat-icon>
              schedule
            </mat-icon>

            {{ liste.importedAtUtc | date:'dd.MM.yyyy HH:mm' }}

            <ng-container *ngIf="liste.importedByName">

              &nbsp;· {{ liste.importedByName }}

            </ng-container>

          </span>

        </div>


        <div class="projekt-zuordnung-fehler" *ngIf="projektAssignmentError">

          <mat-icon>
            error_outline
          </mat-icon>

          {{ projektAssignmentError }}

        </div>

      </mat-card-content>

    </mat-card>


    <!-- =====================================================
         PFLEGE DER LISTE

         Beides braucht den Server: eine Messstelle ergänzen und eine
         neue Excel-Revision abgleichen. Ohne Verbindung werden die
         Schaltflächen deshalb gar nicht erst angeboten.
         ===================================================== -->

    <div class="listen-aktionen listen-aktionen-v10" *ngIf="!istOffline">

      <button mat-stroked-button type="button" (click)="neueMessstelleOeffnen()" [disabled]="zeigeNeueMessstelle">
        <mat-icon>add</mat-icon>
        Messstelle hinzufügen
      </button>

      <button mat-stroked-button type="button" (click)="abgleichOeffnen()" [disabled]="zeigeAbgleich">
        <mat-icon>difference</mat-icon>
        Excel abgleichen
      </button>

      <!-- Nur manuell erstellte Listen haben eine bearbeitbare Spaltenstruktur -->
      <ng-container *ngIf="istManuelleListe && canEdit">
        <button mat-stroked-button type="button" (click)="strukturBearbeiten()"
          matTooltip="Spalten ergänzen, umbenennen, sortieren oder die Kennzeichnungsspalte wechseln">
          <mat-icon>view_column</mat-icon>
          Struktur bearbeiten
        </button>

        <button mat-stroked-button type="button" (click)="alsVorlageSpeichern()"
          matTooltip="Die Spaltenstruktur dieser Liste als Vorlage für weitere Listen speichern">
          <mat-icon>bookmark_add</mat-icon>
          Als Vorlage speichern
        </button>
      </ng-container>

      <ng-container *ngIf="kannSammelZuordnen">
        <button mat-icon-button type="button" class="listen-mehr-button-v10" [matMenuTriggerFor]="listenPflegeMenu"
          matTooltip="Weitere Aktionen" aria-label="Weitere Aktionen zur Listenpflege">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #listenPflegeMenu="matMenu">
          <button mat-menu-item type="button" (click)="sammelOeffnen('kategorie')"
            [disabled]="sammelArt === 'kategorie' || sammelSpeichert">
            <mat-icon>category</mat-icon>
            <span>Kategorien zuordnen</span>
          </button>
          <button mat-menu-item type="button" (click)="sammelOeffnen('anlagenteil')"
            [disabled]="sammelArt === 'anlagenteil' || sammelSpeichert">
            <mat-icon>account_tree</mat-icon>
            <span>Anlagenteile zuordnen</span>
          </button>
        </mat-menu>
      </ng-container>

    </div>


    <!--
      KATEGORIEN / ANLAGENTEILE PER REGEL ZUORDNEN

      Dieselbe Regel-Logik wie beim Import, nachträglich auf die bestehende
      Liste. Erst Vorschau, dann Bestätigung – geändert wird in einem Request.
    -->
    <mat-card class="pflege-card" *ngIf="sammelArt && kannSammelZuordnen">

      <mat-card-content>

        <h2 class="pflege-titel">
          {{ sammelArt === 'kategorie' ? 'Kategorien per Regel zuordnen' : 'Anlagenteile per Regel zuordnen' }}
        </h2>

        <p class="pflege-hinweis">
          Dieselben Regeln wie beim Import: sie prüfen den Wert eines Standardfelds,
          z. B. „Langtext enthält Pumpe“. Treffen mehrere Regeln auf eine Messstelle zu,
          gilt die erste. Geändert wird erst nach „Übernehmen“ und nur in dieser
          Inbetriebnahme – vorhandene Zuordnungen werden dabei überschrieben.
          <ng-container *ngIf="sammelArt === 'anlagenteil'">
            Ein noch unbekannter Anlagenteil wird beim Übernehmen angelegt.
          </ng-container>
        </p>

        <div class="regel-block" *ngFor="let regel of sammelRegeln; let i = index">

          <div class="regel-zeile">

            <mat-form-field appearance="outline" class="regel-feld">
              <mat-label>Feld</mat-label>
              <mat-select [(ngModel)]="regel.feld" (selectionChange)="sammelAktualisieren()">
                <mat-option *ngFor="let f of regelFelder" [value]="f">
                  {{ istManuelleListe ? f : feldAnzeige(f) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="regel-operator">
              <mat-label>Bedingung</mat-label>
              <mat-select [(ngModel)]="regel.operator" (selectionChange)="sammelAktualisieren()">
                <mat-option *ngFor="let o of operatoren" [value]="o.wert">{{ o.text }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="regel-wert">
              <mat-label>Wert</mat-label>
              <input matInput [(ngModel)]="regel.wert" (ngModelChange)="sammelAktualisieren()"
                [placeholder]="sammelArt === 'kategorie' ? 'z.B. Pumpe' : 'z.B. UKR12'">
            </mat-form-field>

            <app-kategorie-auswahl class="regel-feld" *ngIf="sammelArt === 'kategorie'" [kategorien]="kategorienAuswahl"
              leerText="— wählen —" [(ngModel)]="regel.kategorieId" (valueChange)="sammelAktualisieren()">
            </app-kategorie-auswahl>

            <mat-form-field appearance="outline" class="regel-wert" *ngIf="sammelArt === 'anlagenteil'">
              <mat-label>Anlagenteil</mat-label>
              <input matInput [(ngModel)]="regel.anlagenteilName" (ngModelChange)="sammelAktualisieren()"
                [matAutocomplete]="anlagenteilAuswahl" placeholder="z.B. Wärmespeicher">
              <mat-autocomplete #anlagenteilAuswahl="matAutocomplete">
                <mat-option *ngFor="let a of anlagenteilVorschlaege(regel)" [value]="a.name">
                  {{ a.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <span class="regel-treffer" *ngIf="regel.ergebnis as e">
              {{ e.treffer }} Treffer
            </span>

            <button mat-icon-button type="button" (click)="sammelRegelEntfernen(i)" matTooltip="Regel entfernen"
              [disabled]="sammelSpeichert">
              <mat-icon>close</mat-icon>
            </button>

          </div>

          <div class="regel-info" *ngIf="regel.ergebnis || (sammelArt === 'anlagenteil' && istNeuerAnlagenteil(regel))">

            <span class="regel-neu" *ngIf="sammelArt === 'anlagenteil' && istNeuerAnlagenteil(regel)">
              wird neu angelegt
            </span>

            <ng-container *ngIf="regel.ergebnis as e">

              <span>
                {{ e.aenderungen }} Messstelle{{ e.aenderungen === 1 ? '' : 'n' }} durch diese Regel geändert
                <ng-container *ngIf="e.treffer > e.aenderungen">
                  (übrige Treffer sind bereits so zugeordnet oder von einer früheren Regel belegt)
                </ng-container>
              </span>

              <button mat-button type="button" class="regel-beispiele-toggle" *ngIf="e.beispiele.length > 0"
                (click)="regel.zeigeBeispiele = !regel.zeigeBeispiele">
                <mat-icon inline>{{ regel.zeigeBeispiele ? 'expand_less' : 'expand_more' }}</mat-icon>
                Beispiele
              </button>

            </ng-container>

          </div>

          <ul class="regel-beispiele"
            *ngIf="regel.zeigeBeispiele && regel.ergebnis && regel.ergebnis.beispiele.length > 0">
            <li *ngFor="let b of regel.ergebnis.beispiele">
              {{ b.name }}
              <span class="regel-bisher" *ngIf="b.bisher">bisher: {{ b.bisher }}</span>
            </li>
          </ul>

        </div>

        <button mat-button type="button" (click)="sammelRegelHinzufuegen()" [disabled]="sammelSpeichert">
          <mat-icon>add</mat-icon>
          Regel hinzufügen
        </button>


        <!-- VORSCHAU -->
        <div class="sammel-zusammenfassung" *ngIf="sammelVorschau as v"
          [class.sammel-veraltet]="sammelVorschauVeraltet || sammelVorschauLaeuft">

          <strong>
            {{ v.betroffen }} Messstelle{{ v.betroffen === 1 ? ' wird' : 'n werden' }} geändert
          </strong>

          <span *ngIf="v.ueberschrieben > 0">
            · davon {{ v.ueberschrieben }} mit bereits vorhandener
            {{ sammelArt === 'kategorie' ? 'Kategorie' : 'Anlagenteil-Zuordnung' }} (wird überschrieben)
          </span>

          <span *ngIf="v.unveraendert > 0">
            · {{ v.unveraendert }} bereits so zugeordnet
          </span>

          <span *ngIf="v.neueAnlagenteile.length > 0">
            · neu: {{ v.neueAnlagenteile.join(', ') }}
          </span>

        </div>

        <p class="pflege-hinweis sammel-leer" *ngIf="!sammelVorschau && !sammelVorschauLaeuft && !sammelFehler">
          Die Vorschau erscheint, sobald eine Regel vollständig ausgefüllt ist.
        </p>

        <div class="abgleich-warnung" *ngFor="let w of sammelVorschau?.warnungen ?? []">
          <mat-icon inline>report_problem</mat-icon> {{ w }}
        </div>

        <div class="pflege-fehler" *ngIf="sammelFehler">
          <mat-icon inline>error_outline</mat-icon> {{ sammelFehler }}
        </div>

        <div class="pflege-aktionen">

          <button mat-raised-button color="primary" type="button" [disabled]="!kannSammelAnwenden"
            (click)="sammelAnwenden()">
            <mat-icon>done_all</mat-icon>
            Übernehmen
          </button>

          <mat-spinner diameter="22" *ngIf="sammelVorschauLaeuft || sammelSpeichert"></mat-spinner>

          <button mat-button type="button" (click)="sammelSchliessen()" [disabled]="sammelSpeichert">
            Abbrechen
          </button>

        </div>

      </mat-card-content>

    </mat-card>


    <!-- MESSSTELLE ERGÄNZEN -->
    <mat-card class="pflege-card" *ngIf="zeigeNeueMessstelle">

      <mat-card-content>

        <h2 class="pflege-titel">
          {{ liste.listenTyp === 'Verbraucherliste' ? 'Verbraucher hinzufügen' : 'Messstelle hinzufügen' }}
        </h2>

        <p class="pflege-hinweis" *ngIf="!istManuelleListe">
          Fehlende Spalten werden bei Bedarf für die gesamte Liste ergänzt.
        </p>

        <p class="pflege-hinweis" *ngIf="istManuelleListe">
          Die Felder entsprechen der Spaltenstruktur dieser Liste. Die Kennzeichnung
          <strong>{{ strukturKennzeichnung?.name }}</strong> ist Pflicht und muss in der Liste eindeutig sein;
          Felder mit * sind Pflichtfelder.
        </p>

        <!-- Importierte Liste: die festen Standardfelder des Listentyps -->
        <div class="neue-felder" *ngIf="!istManuelleListe">

          <mat-form-field appearance="outline" *ngFor="let feld of standardFelder">

            <mat-label>{{ feldAnzeige(feld) }}</mat-label>
            <input matInput [(ngModel)]="neueWerte[feld]">

          </mat-form-field>

        </div>

        <!-- Manuell erstellte Liste: Formular aus der Struktur – Datentyp, Pflicht, Kennzeichnung -->
        <div class="neue-felder" *ngIf="istManuelleListe">

          <mat-form-field appearance="outline" *ngFor="let spalte of strukturSpalten; trackBy: trackBySpalte"
            [class.neues-feld-kennz]="spalte.istKennzeichnung">

            <mat-label>
              <mat-icon class="feld-kennz-icon" inline *ngIf="spalte.istKennzeichnung">key</mat-icon>
              {{ spalte.name }}{{ spalte.pflicht ? ' *' : '' }}
            </mat-label>

            <ng-container [ngSwitch]="spalte.datentyp">

              <input *ngSwitchCase="'Zahl'" matInput type="text" inputmode="decimal" [(ngModel)]="neueWerte[spalte.id]"
                placeholder="z. B. 12,5">

              <input *ngSwitchCase="'Datum'" matInput type="date" [(ngModel)]="neueWerte[spalte.id]">

              <mat-select *ngSwitchCase="'JaNein'" [(ngModel)]="neueWerte[spalte.id]">
                <mat-option value="">— nicht gesetzt —</mat-option>
                <mat-option value="Ja">Ja</mat-option>
                <mat-option value="Nein">Nein</mat-option>
              </mat-select>

              <input *ngSwitchDefault matInput type="text" [(ngModel)]="neueWerte[spalte.id]"
                [placeholder]="spalte.istKennzeichnung ? 'eindeutige ' + spalte.name : ''">

            </ng-container>

            <mat-hint *ngIf="neueFeldFehler(spalte) as fehler" class="neues-feld-fehler">{{ fehler }}</mat-hint>
            <mat-hint *ngIf="!neueFeldFehler(spalte) && neuePflichtFehlt(spalte)" class="neues-feld-fehler">
              Pflichtfeld
            </mat-hint>

          </mat-form-field>

        </div>

        <div class="neue-zuordnung">

          <app-kategorie-auswahl [kategorien]="kategorienAuswahl" label="Kategorie (optional)"
            hint="Bestimmt die Prüfpunkte der neuen Messstelle." [(ngModel)]="neueKategorieId">
          </app-kategorie-auswahl>

          <mat-form-field appearance="outline" *ngIf="anlagenteile.length > 0">
            <mat-label>Anlagenteil (optional)</mat-label>
            <mat-select [(ngModel)]="neueAnlagenteilId">
              <mat-option [value]="null">— keiner —</mat-option>
              <mat-option *ngFor="let a of anlagenteile" [value]="a.id">
                {{ a.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div class="pflege-fehler" *ngIf="neueFehler">
          <mat-icon inline>error_outline</mat-icon> {{ neueFehler }}
        </div>

        <div class="pflege-aktionen">
          <button mat-raised-button color="primary" type="button" [disabled]="!kannNeueSpeichern"
            (click)="neueMessstelleSpeichern()">
            <mat-icon>save</mat-icon>
            Speichern
          </button>

          <mat-spinner diameter="22" *ngIf="speichertNeue"></mat-spinner>

          <button mat-button type="button" (click)="neueMessstelleAbbrechen()">
            Abbrechen
          </button>
        </div>

      </mat-card-content>

    </mat-card>


    <!-- ABGLEICH MIT EINER NEUEREN EXCEL-DATEI -->
    <mat-card class="pflege-card" *ngIf="zeigeAbgleich">

      <mat-card-content>

        <h2 class="pflege-titel">Mit einer neueren Excel-Datei abgleichen</h2>

        <p class="pflege-hinweis">
          Die Datei wird nur verglichen, nichts wird überschrieben. Prüfpunkte,
          Prüfergebnisse, Bemerkungen, Protokolle und Fotos bleiben in jedem Fall
          erhalten – auch bei Messstellen, die in der neuen Datei fehlen.
        </p>

        <div class="pflege-aktionen">

          <button mat-stroked-button color="primary" type="button" (click)="abgleichInput.click()"
            [disabled]="abgleichLaeuft">
            <mat-icon>attach_file</mat-icon>
            Neue Datei wählen
          </button>

          <input #abgleichInput type="file" accept=".xlsx,.xlsm,.xls" hidden (change)="onAbgleichDatei($event)">

          <span class="datei-name" *ngIf="abgleichDatei">{{ abgleichDatei.name }}</span>

          <mat-spinner diameter="22" *ngIf="abgleichLaeuft"></mat-spinner>

          <button mat-button type="button" (click)="abgleichSchliessen()">
            Schließen
          </button>

        </div>

        <div class="pflege-fehler" *ngIf="abgleichFehler">
          <mat-icon inline>error_outline</mat-icon> {{ abgleichFehler }}
        </div>

        <ng-container *ngIf="abgleich as ergebnis">

          <!--
            Der häufigste Fall beim Prüfen einer Revision: es hat sich nichts
            geändert. Dann soll genau das dastehen – und keine Liste, die man
            erst durchsehen muss, um zum selben Schluss zu kommen.
          -->
          <div class="abgleich-gleich" *ngIf="keineUnterschiede">
            <mat-icon>check_circle</mat-icon>
            <div>
              <strong>Keine Änderungen gefunden.</strong>
              {{ ergebnis.anzahlUnveraendert }} Einträge unverändert – weder Zeilen
              noch Spalten noch Werte weichen ab. Es gibt nichts zu übernehmen.
            </div>
          </div>

          <!--
            Ohne erkennbare Kennzeichnung wird NICHT über Zeilennummern
            geraten: eine einzige eingefügte Zeile verschöbe alles darunter.
            Statt erfundener Änderungen fragt die Seite, worüber verglichen
            werden soll.
          -->
          <div class="abgleich-spaltenwahl" *ngIf="brauchtVergleichsSpalte">
            <div class="spaltenwahl-text">
              <mat-icon inline>help_outline</mat-icon>
              <span>
                In dieser Datei liess sich keine Kennzeichnung erkennen, über die
                sich beide Seiten sicher zuordnen lassen. Bitte die Spalte wählen,
                die die Messstellen eindeutig benennt.
              </span>
            </div>

            <mat-form-field appearance="outline" class="spaltenwahl-feld">
              <mat-label>Vergleichsspalte</mat-label>
              <mat-select [value]="vergleichsSpalte" [disabled]="abgleichLaeuft"
                (selectionChange)="vergleichsSpalteAnwenden($event.value)">
                <mat-option *ngFor="let s of vergleichsSpaltenVorschlaege" [value]="s">
                  {{ s }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!--
            Worüber tatsächlich zugeordnet wurde. Beide Dateien dürfen die
            Spalte anders benennen – verglichen wird die Bedeutung.
          -->
          <p class="abgleich-spaltenherkunft" *ngIf="!brauchtVergleichsSpalte && ergebnis.vergleichsSpalte">
            Zugeordnet über <strong>{{ ergebnis.vergleichsSpalte }}</strong>
            <ng-container *ngIf="ergebnis.vergleichsSpalteBestand
                     && ergebnis.vergleichsSpalteBestand !== ergebnis.vergleichsSpalte">
              (in dieser Liste: <strong>{{ ergebnis.vergleichsSpalteBestand }}</strong>)
            </ng-container>.
          </p>

          <div class="abgleich-warnung" *ngFor="let w of ergebnis.warnungen">
            <mat-icon inline>report_problem</mat-icon> {{ w }}
          </div>

          <ng-container *ngIf="!keineUnterschiede">

            <!--
              ────────────────────────────────────────────────────────────────
              ÜBERBLICK

              Zuerst nur die Zahl: was hat sich geändert? Keine Kästchen, keine
              Einzelentscheidung. Wer eine Revision prüft, will erst wissen,
              worum es überhaupt geht – und in neun von zehn Fällen ist die
              Antwort „das passt, alles übernehmen“.

              Auch die Nullen stehen da. „0 entfernte Spalten“ ist eine
              Aussage; eine fehlende Zeile wäre bloss eine Lücke.
              ────────────────────────────────────────────────────────────────
            -->
            <div class="ab-uebersicht">

              <div class="ab-zahl ab-zahl-neu" [class.ab-zahl-null]="ergebnis.anzahlNeu === 0">
                <span class="ab-zahl-wert">{{ ergebnis.anzahlNeu }}</span>
                <span class="ab-zahl-text">
                  neue Messstelle{{ ergebnis.anzahlNeu === 1 ? '' : 'n' }}
                </span>
              </div>

              <div class="ab-zahl ab-zahl-entfallen" [class.ab-zahl-null]="ergebnis.anzahlEntfallen === 0">
                <span class="ab-zahl-wert">{{ ergebnis.anzahlEntfallen }}</span>
                <span class="ab-zahl-text">nicht mehr in der Datei</span>
              </div>

              <div class="ab-zahl ab-zahl-geaendert" [class.ab-zahl-null]="ergebnis.anzahlGeaendert === 0">
                <span class="ab-zahl-wert">{{ ergebnis.anzahlGeaendert }}</span>
                <span class="ab-zahl-text">geändert</span>
              </div>

              <div class="ab-zahl ab-zahl-struktur" [class.ab-zahl-null]="abgleichNeueSpalten.length === 0">
                <span class="ab-zahl-wert">{{ abgleichNeueSpalten.length }}</span>
                <span class="ab-zahl-text">
                  neue Spalte{{ abgleichNeueSpalten.length === 1 ? '' : 'n' }}
                </span>
              </div>

              <div class="ab-zahl ab-zahl-struktur" [class.ab-zahl-null]="abgleichEntfalleneSpalten.length === 0">
                <span class="ab-zahl-wert">{{ abgleichEntfalleneSpalten.length }}</span>
                <span class="ab-zahl-text">
                  entfernte Spalte{{ abgleichEntfalleneSpalten.length === 1 ? '' : 'n' }}
                </span>
              </div>

            </div>

            <p class="ab-uebersicht-fuss">
              {{ ergebnis.anzahlUnveraendert }} Messstellen unverändert.
              <ng-container *ngIf="abgleichUnsicher.length > 0">
                {{ abgleichUnsicher.length }} unsicher – bitte prüfen.
              </ng-container>
              <ng-container *ngIf="abgleichOhneKennzeichnung.length > 0">
                {{ abgleichOhneKennzeichnung.length }} Zeilen ohne Kennzeichnung
                (Gruppenköpfe, Summen, Zubehör) werden nicht verglichen.
              </ng-container>
            </p>


            <!--
              Die Schaltflächen stehen oben UND unten: bei 400 geänderten
              Messstellen ist der Weg ans Listenende sonst der Preis dafür,
              „übernehmen“ zu sagen.
            -->
            <ng-template #abgleichAktionen>

              <div class="ab-aktionen" *ngIf="!abgleichBearbeiten">
                <button mat-raised-button color="primary" type="button" [disabled]="!kannAbgleichUebernehmen"
                  (click)="abgleichUebernehmen()">
                  <mat-icon>done_all</mat-icon>
                  Alle Änderungen übernehmen
                </button>

                <button mat-stroked-button type="button" (click)="auswahlBearbeiten()">
                  <mat-icon>checklist</mat-icon>
                  Auswahl bearbeiten
                </button>

                <!--
                  Verwerfen heisst hier wirklich verwerfen: der Abgleich war
                  ein Bericht, an der Liste hat sich nichts geändert.
                -->
                <button mat-button type="button" (click)="abgleichVerwerfen()">
                  Änderungen ignorieren
                </button>
              </div>

              <div class="ab-aktionen ab-aktionen-bearbeiten" *ngIf="abgleichBearbeiten">
                <button mat-raised-button color="primary" type="button" [disabled]="!kannAbgleichUebernehmen"
                  (click)="abgleichUebernehmen()">
                  <mat-icon>done_all</mat-icon>
                  {{ gewaehlteAnzahl }} von {{ entscheidbareAnzahl }} übernehmen
                </button>

                <button mat-button type="button" [disabled]="gewaehlteAnzahl === entscheidbareAnzahl"
                  (click)="alleAuswaehlen()">
                  Alle
                </button>

                <button mat-button type="button" [disabled]="gewaehlteAnzahl === 0" (click)="keineAuswaehlen()">
                  Keine
                </button>

                <button mat-button type="button" (click)="abgleichVerwerfen()">
                  Änderungen ignorieren
                </button>
              </div>

            </ng-template>

            <ng-container *ngTemplateOutlet="abgleichAktionen"></ng-container>


            <!--
              ────────────────────────────────────────────────────────────────
              DIE GRUPPEN

              Geändert, neu, nicht mehr in der Datei, Struktur – in dieser
              Reihenfolge, weil das die Reihenfolge ist, in der man sie
              anschaut. Alles, was keine Entscheidung braucht, steht unten und
              zugeklappt.
              ────────────────────────────────────────────────────────────────
            -->

            <!-- GEÄNDERTE MESSSTELLEN -->
            <section class="ab-gruppe" *ngIf="abgleichGeaendert.length > 0">
              <h3 class="ab-gruppe-titel">
                <mat-icon inline>edit</mat-icon>
                Geänderte Messstellen
                <span class="ab-gruppe-anzahl">{{ abgleichGeaendert.length }}</span>
              </h3>

              <div class="ab-eintrag" *ngFor="let e of abgleichGeaendert">

                <div class="ab-eintrag-kopf">
                  <mat-checkbox *ngIf="abgleichBearbeiten" [checked]="istMessstelleGanzGewaehlt(e)"
                    [indeterminate]="istMessstelleTeilweiseGewaehlt(e)" (change)="toggleMessstelle(e)">
                  </mat-checkbox>

                  <span class="ab-kennung">{{ e.kennzeichnung || e.anzeigename }}</span>

                  <span class="ab-eintrag-name" *ngIf="e.kennzeichnung && e.anzeigename !== e.kennzeichnung">
                    {{ e.anzeigename }}
                  </span>
                </div>

                <ul class="ab-felder">
                  <li class="ab-feld" *ngFor="let u of e.unterschiede">

                    <mat-checkbox *ngIf="abgleichBearbeiten" [checked]="istFeldGewaehlt(e, u.spalte)"
                      (change)="toggleFeld(e, u.spalte)">
                    </mat-checkbox>

                    <span class="ab-feld-name">{{ u.spalte }}:</span>

                    <span class="ab-feld-werte">
                      <span class="ab-alt">{{ u.alt || '—' }}</span>
                      <mat-icon inline>arrow_right_alt</mat-icon>
                      <span class="ab-neu">{{ u.neu }}</span>
                    </span>

                  </li>
                </ul>

              </div>
            </section>


            <!-- NEUE MESSSTELLEN -->
            <section class="ab-gruppe" *ngIf="abgleichNeu.length > 0">
              <h3 class="ab-gruppe-titel">
                <mat-icon inline>add_circle_outline</mat-icon>
                Neue Messstellen
                <span class="ab-gruppe-anzahl">{{ abgleichNeu.length }}</span>
              </h3>

              <div class="ab-eintrag ab-eintrag-schmal" *ngFor="let e of abgleichNeu">
                <div class="ab-eintrag-kopf">
                  <mat-checkbox *ngIf="abgleichBearbeiten" [checked]="istZeileGewaehlt(e)" (change)="toggleZeile(e)">
                  </mat-checkbox>

                  <span class="ab-kennung">{{ e.kennzeichnung || e.anzeigename }}</span>

                  <span class="ab-eintrag-name" *ngIf="e.kennzeichnung && e.anzeigename !== e.kennzeichnung">
                    {{ e.anzeigename }}
                  </span>
                </div>
              </div>
            </section>


            <!-- NICHT MEHR IN DER DATEI -->
            <section class="ab-gruppe" *ngIf="abgleichEntfallen.length > 0">
              <h3 class="ab-gruppe-titel">
                <mat-icon inline>remove_circle_outline</mat-icon>
                Nicht mehr in der Datei
                <span class="ab-gruppe-anzahl">{{ abgleichEntfallen.length }}</span>
              </h3>

              <p class="ab-gruppe-hinweis">
                Diese Messstellen bleiben standardmäßig erhalten – samt Prüfpunkten, Ergebnissen,
                Notizen, Aktivitätsverlauf und Fotos. Nur einzeln angehakte Messstellen werden beim
                Übernehmen endgültig gelöscht („alle auswählen“ hakt sie bewusst nicht an).
                <ng-container *ngIf="entfalleneZumLoeschen > 0">
                  <strong>{{ entfalleneZumLoeschen }} zum Löschen angehakt.</strong>
                </ng-container>
              </p>

              <div class="ab-eintrag ab-eintrag-schmal ab-eintrag-entfallen" *ngFor="let e of abgleichEntfallen">
                <div class="ab-eintrag-kopf">
                  <mat-checkbox *ngIf="abgleichBearbeiten && e.messstelleId != null" color="warn"
                    [checked]="istEntfallenGewaehlt(e)" (change)="toggleEntfallen(e)"
                    matTooltip="Diese Messstelle samt Prüfpunkten, Protokoll und Fotos löschen">
                  </mat-checkbox>
                  <span class="ab-kennung">{{ e.kennzeichnung || e.anzeigename }}</span>
                  <span class="ab-eintrag-name" *ngIf="e.kennzeichnung && e.anzeigename !== e.kennzeichnung">
                    {{ e.anzeigename }}
                  </span>
                  <span class="ab-eintrag-name" *ngIf="istEntfallenGewaehlt(e)"><strong>wird gelöscht</strong></span>
                </div>
              </div>
            </section>


            <!--
              STRUKTURÄNDERUNGEN

              Der ganze Grund für diese Gruppe: eine neue Spalte ist EIN
              Ereignis für die Liste. Früher stand sie zusätzlich bei jeder
              einzelnen Messstelle als „— → Wert“ – aus einer Änderung wurden
              vierhundert, und der Bericht war nicht mehr lesbar.
            -->
            <section class="ab-gruppe" *ngIf="abgleichStruktur.length > 0">
              <h3 class="ab-gruppe-titel">
                <mat-icon inline>view_column</mat-icon>
                Strukturänderungen
                <span class="ab-gruppe-anzahl">{{ abgleichStruktur.length }}</span>
              </h3>

              <p class="ab-gruppe-hinweis">
                Diese Änderungen betreffen den Aufbau der Liste, nicht einzelne
                Messstellen. Sie werden einmal entschieden und gelten dann für
                alle zugeordneten Zeilen.
              </p>

              <div class="ab-eintrag ab-struktur" *ngFor="let s of abgleichStruktur"
                [class.ab-struktur-info]="!s.uebernehmbar">

                <div class="ab-eintrag-kopf">
                  <mat-checkbox *ngIf="abgleichBearbeiten && s.uebernehmbar" [checked]="istStrukturGewaehlt(s)"
                    (change)="toggleStruktur(s)">
                  </mat-checkbox>

                  <mat-icon inline class="ab-struktur-icon">
                    {{ s.art === 'NeueSpalte' ? 'add_circle_outline'
                    : s.art === 'EntfalleneSpalte' ? 'remove_circle_outline'
                    : 'swap_horiz' }}
                  </mat-icon>

                  <span class="ab-kennung">{{ strukturText(s) }}</span>
                </div>

                <p class="ab-struktur-hinweis">{{ strukturHinweis(s) }}</p>
              </div>
            </section>


            <!--
              Zeilen, die schon beim letzten Import bewusst weggelassen wurden
              und seitdem unverändert sind. Sie stehen NICHT unter „neu“ – die
              Entscheidung wurde einmal getroffen und wird nicht bei jeder
              Revision erneut verlangt.
            -->
            <section class="ab-gruppe" *ngIf="abgleichAusgeschlossen.length > 0">
              <h3 class="ab-gruppe-titel">
                <mat-icon inline>block</mat-icon>
                Beim Import ausgeschlossen
                <span class="ab-gruppe-anzahl">{{ abgleichAusgeschlossen.length }}</span>
              </h3>

              <p class="ab-gruppe-hinweis">
                Diese Zeilen stehen weiterhin in der Datei, wurden aber beim
                Import bewusst weggelassen. Sie bleiben ausgeschlossen – wer
                eine davon doch braucht, hakt sie im Bearbeitungsmodus an.
              </p>

              <div class="ab-eintrag ab-eintrag-schmal" *ngFor="let e of abgleichAusgeschlossen">
                <div class="ab-eintrag-kopf">
                  <mat-checkbox *ngIf="abgleichBearbeiten" [checked]="istZeileGewaehlt(e)" (change)="toggleZeile(e)">
                  </mat-checkbox>

                  <span class="ab-kennung">{{ e.kennzeichnung || e.anzeigename }}</span>
                  <span class="ab-eintrag-grund" *ngIf="e.ausschlussGrund">
                    {{ e.ausschlussGrund }}
                  </span>
                </div>
              </div>
            </section>


            <section class="ab-gruppe" *ngIf="abgleichUnsicher.length > 0">
              <h3 class="ab-gruppe-titel">
                <mat-icon inline>help_outline</mat-icon>
                Unsicher – bitte prüfen
                <span class="ab-gruppe-anzahl">{{ abgleichUnsicher.length }}</span>
              </h3>

              <p class="ab-gruppe-hinweis">
                Hier ist die Zuordnung nicht eindeutig – meist eine mehrfach
                vergebene Kennzeichnung. Diese Zeilen werden nie automatisch
                übernommen.
              </p>

              <div class="ab-eintrag ab-eintrag-schmal ab-eintrag-unsicher" *ngFor="let e of abgleichUnsicher">
                <div class="ab-eintrag-kopf">
                  <span class="ab-kennung">{{ e.kennzeichnung || e.anzeigename }}</span>
                </div>
              </div>
            </section>


            <!--
              Der Regelfall, und deshalb zugeklappt: unveränderte Messstellen
              und die Zeilen, die gar keine sind. Beides ist die Bestätigung,
              dass nichts zu tun ist, und keine Arbeitsliste.
            -->
            <section class="ab-gruppe ab-gruppe-still" *ngIf="abgleichUnveraendert.length > 0">
              <button type="button" class="ab-gruppe-toggle" (click)="zeigeUnveraenderte = !zeigeUnveraenderte">
                <mat-icon inline>{{ zeigeUnveraenderte ? 'expand_less' : 'expand_more' }}</mat-icon>
                Unverändert
                <span class="ab-gruppe-anzahl">{{ abgleichUnveraendert.length }}</span>
              </button>

              <ng-container *ngIf="zeigeUnveraenderte">
                <div class="ab-eintrag ab-eintrag-schmal ab-eintrag-still" *ngFor="let e of abgleichUnveraendert">
                  <div class="ab-eintrag-kopf">
                    <span class="ab-kennung">{{ e.kennzeichnung || e.anzeigename }}</span>
                  </div>
                </div>
              </ng-container>
            </section>

            <section class="ab-gruppe ab-gruppe-still" *ngIf="abgleichOhneKennzeichnung.length > 0">
              <button type="button" class="ab-gruppe-toggle" (click)="zeigeOhneKennzeichnung = !zeigeOhneKennzeichnung">
                <mat-icon inline>{{ zeigeOhneKennzeichnung ? 'expand_less' : 'expand_more' }}</mat-icon>
                Nicht als Messstelle erkannt
                <span class="ab-gruppe-anzahl">{{ abgleichOhneKennzeichnung.length }}</span>
              </button>

              <ng-container *ngIf="zeigeOhneKennzeichnung">
                <p class="ab-gruppe-hinweis">
                  Gruppenköpfe, Summen-, Zubehör- und Hilfszeilen. Sie tragen
                  keine Kennzeichnung, lassen sich deshalb nicht zuordnen und
                  werden nicht verglichen – sie erzeugen keine
                  Messstellenänderung.
                </p>

                <div class="ab-eintrag ab-eintrag-schmal ab-eintrag-still" *ngFor="let e of abgleichOhneKennzeichnung">
                  <div class="ab-eintrag-kopf">
                    <span class="ab-kennung">{{ e.anzeigename }}</span>
                  </div>
                </div>
              </ng-container>
            </section>


            <ng-container *ngTemplateOutlet="abgleichAktionen"></ng-container>

          </ng-container>

        </ng-container>

      </mat-card-content>

    </mat-card>


    <!-- =====================================================
         TABELLE
         ===================================================== -->

    <mat-card class="table-card">

      <mat-card-content>


        <!-- =================================================
             FILTER
             ================================================= -->

        <div class="filter-bar" data-wizard-target="liste-filter">


          <!-- SUCHE -->
          <mat-form-field appearance="outline" class="search-field">

            <mat-label>
              Messstellen durchsuchen
            </mat-label>

            <input matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()"
              placeholder="Kennzeichen, Bezeichnung, Anlage …">

            <mat-icon matPrefix>
              search
            </mat-icon>

            <button mat-icon-button matSuffix type="button" *ngIf="searchTerm" (click)="clearSearch()">

              <mat-icon>
                close
              </mat-icon>

            </button>

          </mat-form-field>


          <!-- KATEGORIE -->
          <mat-form-field appearance="outline" class="filter-field">

            <mat-label>
              Kategorie
            </mat-label>

            <mat-select [(ngModel)]="selectedKategorie" (selectionChange)="applyFilter()">

              <mat-option value="">
                Alle Kategorien
              </mat-option>

              <mat-option value="__keine__">
                Keine Kategorie
              </mat-option>

              <mat-option *ngFor="let kategorie of kategorien" [value]="kategorie">

                {{ kategorie }}

              </mat-option>

            </mat-select>

          </mat-form-field>


          <!-- STATUS -->
          <mat-form-field appearance="outline" class="filter-field">

            <mat-label>
              Status
            </mat-label>

            <mat-select [(ngModel)]="selectedStatus" (selectionChange)="applyFilter()">

              <mat-option value="alle">
                Alle Status
              </mat-option>

              <mat-option value="nichtGestartet">
                Nicht gestartet
              </mat-option>

              <mat-option value="offen">
                Offen
              </mat-option>

              <mat-option value="geprueft">
                Geprüft
              </mat-option>

            </mat-select>

          </mat-form-field>


          <!-- SIGNALSTATUS -->
          <mat-form-field appearance="outline" class="filter-field">

            <mat-label>
              Signalstatus
            </mat-label>

            <mat-select [(ngModel)]="selectedSignalStatus" (selectionChange)="applyFilter()">

              <mat-option value="">
                Alle Signalstatus
              </mat-option>

              <mat-option *ngFor="let opt of signalStatusOptionen" [value]="'' + opt.wert">

                {{ opt.text }}

              </mat-option>

            </mat-select>

          </mat-form-field>


          <!--
            ANLAGENTEIL

            Wirkt zusätzlich zu Suche, Kategorie und Status, nicht statt
            ihnen. Listenbezogen: nur Anlagenteile, die Messstellen DIESER
            Liste tragen (filterAnlagenteile) – nicht alle des Projekts, die
            bleiben der Zuordnung vorbehalten. Ohne verwendete Anlagenteile
            entfällt das Feld.
          -->
          <mat-form-field appearance="outline" class="filter-field" *ngIf="filterAnlagenteile.length > 0">

            <mat-label>
              Anlagenteil
            </mat-label>

            <mat-select [(ngModel)]="selectedAnlagenteil" (selectionChange)="applyFilter()">

              <mat-option value="">
                Alle Anlagenteile
              </mat-option>

              <mat-option value="__keiner__" *ngIf="hatMessstellenOhneAnlagenteil">
                Ohne Zuordnung
              </mat-option>

              <mat-option *ngFor="let a of filterAnlagenteile" [value]="'' + a.id">

                {{ a.name }} ({{ a.messstellenCount }})

                <span class="anlagenteil-herkunft" *ngIf="anlagenteilHerkunft(a) as roh">

                  {{ roh }}

                </span>

              </mat-option>

            </mat-select>

          </mat-form-field>


          <!-- FILTER ZURÜCKSETZEN -->
          <button mat-stroked-button type="button" class="reset-filter-button" *ngIf="hatAktiveFilter"
            (click)="clearAllFilters()">

            <mat-icon>
              filter_alt_off
            </mat-icon>

            Filter zurücksetzen

          </button>

        </div>


        <!-- ERGEBNISINFO -->
        <div class="filter-result-info">

          <span>
            {{ dataSource.filteredData.length }}
            von
            {{ dataSource.data.length }}
            Messstellen
          </span>

        </div>


        <!-- KEINE ERGEBNISSE -->
        <p class="no-results" *ngIf="dataSource.filteredData.length === 0">

          Keine Messstelle passt zu den ausgewählten Filtern.

        </p>


        <!-- =================================================
             TABELLE (Desktop)

             Bleibt auch auf Mobile im DOM und wird dort nur
             ausgeblendet – siehe seitenMessstellen$. Dank
             Seitengröße 5 sind das dann höchstens fünf Zeilen.
             ================================================= -->

        <div class="desktop-messstellen" [hidden]="istMobil">

          <div class="table-scroll" [hidden]="dataSource.filteredData.length === 0">

            <table mat-table [dataSource]="dataSource" matSort>


              <!-- ZEILE -->
              <ng-container matColumnDef="__row">

                <th mat-header-cell *matHeaderCellDef mat-sort-header class="row-col">
                  Zeile
                </th>

                <td mat-cell *matCellDef="let m" class="row-col">

                  <div class="row-col-inhalt">

                    <span>{{ m.rowNumber }}</span>

                    <!--
                      Duplizieren: öffnet NICHT zusätzlich die Messstelle. Offline
                      sichtbar, aber ausgegraut – der Tooltip auf dem Span sagt warum
                      (ein deaktivierter Knopf zeigt selbst keinen).
                    -->
                    <span class="aktion-wrap" *ngIf="canEdit" [matTooltip]="duplizierenTooltip">
                      <button mat-icon-button type="button" class="loeschen-btn duplizieren-btn"
                        [disabled]="!kannDuplizieren || dupliziertMessstelleId !== null"
                        aria-label="Messstelle duplizieren" (click)="messstelleDuplizieren(m, $event)"
                        (keydown.enter)="$event.stopPropagation()">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                    </span>

                    <!-- Löschen: öffnet NICHT zusätzlich die Messstelle. -->
                    <button mat-icon-button type="button" class="loeschen-btn" *ngIf="kannLoeschen"
                      [disabled]="loeschtMessstelleId === m.id" matTooltip="Messstelle löschen"
                      aria-label="Messstelle löschen" (click)="messstelleLoeschen(m, $event)"
                      (keydown.enter)="$event.stopPropagation()">
                      <mat-icon>delete_outline</mat-icon>
                    </button>

                  </div>

                </td>

              </ng-container>


              <!-- ANLAGENTEIL -->
              <ng-container matColumnDef="__anlagenteil">

                <th mat-header-cell *matHeaderCellDef mat-sort-header class="anlagenteil-col">
                  Anlagenteil
                </th>

                <td mat-cell *matCellDef="let m" class="anlagenteil-col">

                  <span class="anlagenteil-chip" *ngIf="anlagenteilName(m) as name"
                    [class.anlagenteil-chip--fremd]="anlagenteilFremd(m)"
                    [matTooltip]="anlagenteilFremd(m) ? 'Der gespeicherte Anlagenteil gehört zu einem anderen Projekt und steht hier nicht zur Auswahl.' : ''">
                    <mat-icon *ngIf="anlagenteilFremd(m)">warning_amber</mat-icon>
                    <span>{{ name }}</span>
                  </span>

                </td>

              </ng-container>


              <!-- EXCEL-SPALTEN -->
              <ng-container *ngFor="let col of liste.columns" [matColumnDef]="col">

                <!--
                Beschriftet wird fachlich: oben das Standardfeld aus der
                Zuordnung, darunter klein der originale Excel-Spaltenname.
                Sagen beide dasselbe, entfällt die zweite Zeile.
              -->
                <th mat-header-cell *matHeaderCellDef mat-sort-header [matTooltip]="spaltenKopf(col).hinweis"
                  [class.kennz-col]="istKennzeichnungSpalte(col)">

                  <span class="spalten-kopf">

                    <span class="spalten-kopf-feld">
                      <mat-icon class="kennz-col-icon" inline *ngIf="istKennzeichnungSpalte(col)">key</mat-icon>
                      {{ spaltenKopf(col).titel }}
                    </span>

                    <span class="spalten-kopf-original" *ngIf="spaltenKopf(col).herkunft as original">
                      {{ original }}
                    </span>

                  </span>

                </th>

                <td mat-cell *matCellDef="let m" [matTooltip]="m.values[col] || ''"
                  [class.kennz-col]="istKennzeichnungSpalte(col)">

                  {{ m.values[col] }}

                </td>

              </ng-container>


              <!-- PRÜFUNG -->
              <ng-container matColumnDef="__pruefung">

                <th mat-header-cell *matHeaderCellDef mat-sort-header class="pruef-col">
                  Prüfung
                </th>


                <td mat-cell *matCellDef="let m" class="pruef-col"
                  [attr.data-wizard-target]="!istMobil ? 'liste-messstelle' : null">

                  <div class="pruefung-content">


                    <!-- KATEGORIE -->
                    <div class="pruefung-top">

                      <span class="kategorie-chip" *ngIf="m.kategorieName">

                        {{ m.kategorieName }}

                      </span>


                      <span class="kategorie-fehlt" *ngIf="!m.kategorieName">

                        keine Kategorie

                      </span>


                      <mat-icon class="fertig-icon" *ngIf="isPruefungFertig(m)"
                        matTooltip="Alle Prüfpunkte abgearbeitet">

                        check_circle

                      </mat-icon>

                    </div>


                    <!--
                    SIGNALSTATUS und GESAMTERGEBNIS.
                    Kompakte Chips, damit die Spalte schmal bleibt.
                    Das Ergebnis erscheint erst, wenn eines gefällt wurde.
                  -->
                    <div class="pruefung-chips">

                      <span class="zustand-chip" [ngClass]="signalStatusCss(m)"
                        matTooltip="Signalstatus – Bearbeitungszustand">

                        {{ signalStatusText(m) }}

                      </span>


                      <span class="zustand-chip" *ngIf="hatPruefergebnis(m)" [ngClass]="pruefergebnisCss(m)"
                        matTooltip="Prüfergebnis der Messstelle">

                        {{ pruefergebnisText(m) }}

                      </span>

                    </div>


                    <!-- FORTSCHRITT -->
                    <div class="pruefung-progress" *ngIf="
                      (m.pruefpunkteGesamt ?? 0) > 0
                    ">

                      <div class="pruefung-progress-info">

                        <span class="pruef-stand" [class.pruef-fertig]="
                          isPruefungFertig(m)
                        ">

                          {{ pruefStand(m) }}

                        </span>


                        <span class="pruef-prozent" [class.pruef-fertig]="
                          isPruefungFertig(m)
                        ">

                          {{ pruefProzent(m) }} %

                        </span>

                      </div>


                      <mat-progress-bar mode="determinate" [value]="pruefProzent(m)">
                      </mat-progress-bar>

                    </div>


                    <!-- NICHT GESTARTET -->
                    <span class="nicht-gestartet-badge" *ngIf="
                      (m.pruefpunkteGesamt ?? 0) === 0
                    " matTooltip="Für diese Messstelle sind noch keine Prüfpunkte vorhanden">

                      Nicht gestartet

                    </span>

                  </div>

                </td>

              </ng-container>


              <tr mat-header-row *matHeaderRowDef="
                displayedColumns;
                sticky: true
              ">
              </tr>


              <tr mat-row *matRowDef="
    let row;
    columns: displayedColumns;
  " class="clickable-row" [class.row-fertig]="isPruefungFertig(row)"
                [class.row-neu]="hervorgehobeneMessstelleId === row.id" (click)="openMessstelle(row)"
                matTooltip="Messstelle öffnen">
              </tr>

            </table>

          </div>

        </div>


        <!-- =================================================
             KARTEN (Mobile)

             Dieselbe Datenquelle wie die Tabelle: nur die
             gefilterten Messstellen der aktuellen Seite.
             ================================================= -->

        <div class="mobile-messstellen" *ngIf="istMobil && dataSource.filteredData.length > 0">

          <div class="messstelle-card" *ngFor="
              let m of seitenMessstellen$ | async;
              let ersteKarte = first;
              trackBy: trackByMessstelle
            " [attr.data-wizard-target]="ersteKarte ? 'liste-messstelle' : null"
            [class.card-fertig]="isPruefungFertig(m)" [class.card-neu]="hervorgehobeneMessstelleId === m.id"
            role="button" tabindex="0" (click)="openMessstelle(m)" (keydown.enter)="openMessstelle(m)">

            <div class="card-kopf">

              <div class="card-kopf-rechts">

                <span class="anlagenteil-chip" *ngIf="anlagenteilName(m) as name">
                  {{ name }}
                </span>

                <!-- Duplizieren: öffnet NICHT zusätzlich die Messstelle; offline ausgegraut. -->
                <span class="aktion-wrap karte-aktion-rechts" *ngIf="canEdit" [matTooltip]="duplizierenTooltip">
                  <button mat-icon-button type="button" class="loeschen-btn duplizieren-btn"
                    [disabled]="!kannDuplizieren || dupliziertMessstelleId !== null" aria-label="Messstelle duplizieren"
                    (click)="messstelleDuplizieren(m, $event)" (keydown.enter)="$event.stopPropagation()">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </span>

                <!-- Löschen: öffnet NICHT zusätzlich die Messstelle. -->
                <button mat-icon-button type="button" class="loeschen-btn" *ngIf="kannLoeschen"
                  [disabled]="loeschtMessstelleId === m.id" aria-label="Messstelle löschen"
                  (click)="messstelleLoeschen(m, $event)" (keydown.enter)="$event.stopPropagation()">
                  <mat-icon>delete_outline</mat-icon>
                </button>

              </div>

            </div>


            <div class="card-kennung" *ngIf="kennzeichnungWert(m) as kennung">
              {{ kennung }}
            </div>

            <div class="card-langtext" *ngIf="langtextWert(m) as langtext">
              {{ langtext }}
            </div>


            <div class="card-chips">

              <span class="kategorie-chip" *ngIf="m.kategorieName">
                {{ m.kategorieName }}
              </span>

              <span class="kategorie-fehlt" *ngIf="!m.kategorieName">
                keine Kategorie
              </span>

              <span class="zustand-chip" [ngClass]="signalStatusCss(m)">
                {{ signalStatusText(m) }}
              </span>

              <span class="zustand-chip" [ngClass]="pruefergebnisCss(m)">
                {{ pruefergebnisText(m) }}
              </span>

            </div>


            <div class="card-progress" *ngIf="(m.pruefpunkteGesamt ?? 0) > 0">

              <div class="pruefung-progress-info">

                <span class="pruef-stand" [class.pruef-fertig]="isPruefungFertig(m)">
                  {{ pruefStand(m) }}
                </span>

                <span class="pruef-prozent" [class.pruef-fertig]="isPruefungFertig(m)">
                  {{ pruefProzent(m) }} %
                </span>

              </div>

              <mat-progress-bar mode="determinate" [value]="pruefProzent(m)">
              </mat-progress-bar>

            </div>


            <span class="nicht-gestartet-badge" *ngIf="(m.pruefpunkteGesamt ?? 0) === 0">
              Nicht gestartet
            </span>

          </div>

        </div>


        <!--
          PAGINATOR – für beide Ansichten derselbe. Auf Mobile ist die
          Seitengröße fest 5, der Auswahlschalter entfällt.
        -->
        <mat-paginator [pageSizeOptions]="istMobil ? mobileSeitenGroessen : desktopSeitenGroessen"
          [pageSize]="istMobil ? mobileSeitenGroesse : desktopSeitenGroesse" [hidePageSize]="istMobil"
          (page)="onPage($event)" showFirstLastButtons>
        </mat-paginator>

      </mat-card-content>

    </mat-card>

  </ng-container>

</div>